import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { rebootWashboardDevice } from 'api/admin/washboard/washboard';

type RebootWashboardDeviceVariables = {
  deviceId: number;
  deviceName: string;
  skipToast?: boolean;
};

export const useRebootWashboardDevice = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError<{ error: string }>, RebootWashboardDeviceVariables>({
    mutationFn: async ({ deviceId }: RebootWashboardDeviceVariables) => {
      return rebootWashboardDevice(deviceId);
    },
    onSuccess: async (_, variables) => {
      if (!variables.skipToast) {
        toaster('Device rebooted successfully', {
          icon: '✅',
        });
      }
      queryClient.invalidateQueries({ queryKey: ['washboardDevices'] });
    },
    onError: (error, variables) => {
      Sentry.captureException(error);
      if (!variables.skipToast) {
        const errorMessage = error?.response?.data?.error ?? 'Failed to reboot';
        const message = `${errorMessage} (${variables?.deviceName})`;
        toaster(message, {
          icon: '❌',
        });
      }
    },
  });
};
